<template>
  <div>
    <!--<h5>費率公式管理</h5>-->
    <!-- NOTE: Moqups here: https://app.moqups.com/IXZCDxml4A/view/page/ac260f06e -->
    <!-- ACTION BAR -->
    <el-row>
      <el-col :span="24">
        <el-card shadow="never" style="height: 100%;">
          <div class="row">
            <div class="col-6">
              <el-button
                type="warning"
                round
                icon="el-icon-plus"
                @click="dialogs.create.show = true"
              >新增公式</el-button>
              
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <br/>

    <!-- LIST OF Formulas -->
    <data-tables :data="formulas" :pagination-props="{pageSizes: [10, 20, 50]}">

      <el-table-column prop="id" label="ID" align="center" sortable="custom">
        <div slot-scope="{row}" class="d-flex align-items-center">
          <span>{{row.id}}</span>
        </div>
      </el-table-column>
      
      <el-table-column prop="name" label="公式名稱" width="300" >
        <div slot-scope="{row}" class="d-flex align-items-center">
          
          <el-input placeholder="公式名稱" v-model="editableFormula.name" size="mini"
            v-if="editables[row.id] === true"></el-input>
          <span v-else>{{row.name}}</span>
        </div>
      </el-table-column>

      <el-table-column prop="formula" label="公式語法" width="300" >
        <div slot-scope="{row}" class="d-flex align-items-center">
          <el-input placeholder="公式語法" v-model="editableFormula.formula" size="mini"
            v-if="editables[row.id] === true"></el-input>
          <span v-else>{{row.formula}}</span>
        </div>
      </el-table-column>
      

      <el-table-column prop="Actions" label="" min-width="240">
        <div slot-scope="{row}">
          <el-button type="warning" icon="el-icon-edit-outline" circle size="small" v-if="!editables[row.id]"
              @click="toggleEditable(row)" title="編輯"></el-button>
          <el-button type="danger" icon="el-icon-check" circle size="small" v-if="editables[row.id]"
            @click="updateFormula(row)" title="完成編輯"></el-button>
          <el-button type="danger" icon="el-icon-close" circle size="small" v-if="editables[row.id]"
            @click="toggleEditable(row, false)" title="取消編輯"></el-button>
          <el-button type="danger" icon="el-icon-delete" circle size="small" v-if="editables[row.id]"
            @click="deleteFormula(row)" title="刪除此公式"></el-button>
          
        </div>
      </el-table-column>
    </data-tables>

    <!-- CREATE DIALOG -->
    <el-dialog title="新增公式" :visible.sync="dialogs.create.show">
      <el-form :model="dialogs.create.model" label-width="84px">
        <el-form-item label="名稱">
          <el-input v-model="dialogs.create.model.name"></el-input>
        </el-form-item>
        <el-form-item label="公式">
          <el-input v-model="dialogs.create.model.formula"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogs.create.show = false">取消</el-button>
        <el-button type="danger" @click="createFomula">確認新增</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { DataTables } from "vue-data-tables"; //NOTE: You can find doc of this at https://www.njleonzhang.com/vue-data-tables/#/
import axios from 'axios';

export default {
  components: {
    DataTables
  },

  mounted() {
    this.fetchFormulas();
  },

  methods: {

    fetchFormulas() {
      axios.get(`${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/formulas`, {
        //withCredentials: false
      })
      .then(response => {
        // Insert QR code URL as well.
        if (!Array.isArray(response.data))
          throw new Error(`GET /formulas failed somehow.`);
        console.log(response)
        this.formulas = response.data;
      });
    },
    
    toggleEditable(formula, editable) {
      console.log('toggleEditable: ', formula)
      
      this.editables[formula.id] = editable || !this.editables[formula.id];
      if (this.editables[formula.id]) {
        this.editableFormula = Object.assign({
          'name': formula.name,
          'formula': formula.formula
        })
        // this.editableFormula = {
        //   'name': formula.name, 
        //   'formula': formula.formula
        // };
        formula.name += ' ';//NOTE: Otherwise el-table won't update itself.
        formula.name = formula.name.substring(0, formula.name.length - 1);
      }
      else {
        console.log('disabled editable', formula, this.editableFormula);
        this.editableFormula.name += ' ';//NOTE: Otherwise el-table won't update itself.
        this.editableFormula.name = this.editableFormula.name.substring(0, this.editableFormula.name.length - 1);
      }
      // console.log(this.editables);
      
    },

    createFomula() {
      let formula = this.dialogs.create.model;
      axios.post(`${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/formulas`, formula, {
        //withCredentials: false
      })
      .then(response => {
        this.dialogs.create.show = false;
        this.fetchFormulas();
        this.$message({
          type: 'success', message: `公式新增成功！（${formula.name}）`
        });          
      })
      .catch(err => {
        this.dialogs.create.show = false;
        this.$message.error(`公式新增失敗，請稍後重試。`);
      });
    },

    updateFormula(formula) {
      let fId = formula.id;
      // Below 2 line seems redundant
      // formula.name = this.editableFormula.name;
      // formula.formula = this.editableFormula.formula;
      let params = {
        'name': this.editableFormula.name, 
        'formula': this.editableFormula.formula
      };
      
      axios.put(`${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/formulas/${fId}`, this.editableFormula, {
        //withCredentials: false
      })
      .then(response => {
        this.fetchFormulas();
        this.$message({
          type: 'success', message: `公式更新成功！（${this.editableFormula.name}）`
        });      

        formula.name = this.editableFormula.name;
        formula.formula = this.editableFormula.formula;    
        this.toggleEditable(formula, false)
      })
      .catch(err => {
        this.$message.error(`公式更新失敗，請稍後重試。`);
        this.toggleEditable(formula, false)
      });
    },

    deleteFormula(formula) {
      let fId = formula.id;
      this.$confirm(`將永久刪除公式 ${formula.name} ，確定執行嗎？`, '警告', {
        confirmButtonText: '確定', cancelButtonText: '取消', type: 'warning'
      })
      .then(() => {
        axios.delete(`${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/formulas/${fId}`, {
          //withCredentials: false
        })
        .then(response => {
          this.fetchFormulas();
          this.$message({
            type: 'success', message: `公式${formula.name}已刪除。`
          });
        })
        .catch(err => {
          this.$message.error(`無法刪除公式${formula.name}，請稍後重試。`);
        });
      })
      .catch(() => { /* nothing to do? */ });

    }
  },

  data() {
    return {
      formulas: [],
      editables: {},
      editableFormula: {},
      dialogs: {
        create: {
          show: false, 
          model: {
            name: '', 
            formula: ''
          }
        }
      },
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },
    userType() {
      return this.$store.getters.userType; //NOTE: This should be equal to 'gaa'!
    }
  }
};
</script>